import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { ConnectedRouter } from 'connected-react-router';
var propTypes = {
  children: PropTypes.node
};
var defaultProps = {
  children: null
};

var RouterContainer = function RouterContainer(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return React.createElement(ConnectedRouter, props, children);
};

RouterContainer.propTypes = propTypes;
RouterContainer.defaultProps = defaultProps;
export default RouterContainer;


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/react-container/es/RouterContainer.js
// module id = null
// module chunks = 